import React, {Component} from 'react';
import autobind from 'autobind-decorator';

import {service as FileUploadService} from "../../../../Services/FileUploadService";


export const SurveyFormInputFileEnhance = ((ComposedComponent) => class SurveyFormInputFileEnhance extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fileUpload: null
        };
    }

    componentDidMount() {
        if(this.props.Answer) {
            if(this.props.Answer.fileUploadId) {
                this.getFile(this.props.Answer.fileUploadId);
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.Answer) {
            if(!prevProps.Answer || this.props.Answer.fileUploadId != prevProps.Answer.fileUploadId) {
                if(this.props.Answer.fileUploadId) {
                    this.getFile(this.props.Answer.fileUploadId);
                }
            }
        } else {
            if(prevProps.Answer) {
                this.setState({fileUpload: null});
            }
        }
    }


    @autobind
    reloadData() {
        if (this.state.fileUpload) {
            this.getFile(this.state.fileUpload.fileUploadId)
        }
    }

    @autobind
    getFile(fileUploadId) {
        FileUploadService.GetFileUpload(fileUploadId)
            .then((x) => this.setState({fileUpload: x.result}))
            .catch((err) => this.setState({fileUpload: null}));
    }

    @autobind
    downloadFile(fileId) {
        FileUploadService.DownloadFile(this.state.fileUpload.fileName, fileId);
    }

    render() {
        return <ComposedComponent
            SurveyFormInputFile={{
                FileUpload: this.state.fileUpload,
                DownloadFile: this.downloadFile,
                GetFile: this.getFile,
            }}
            {...this.props}
        />;
    }
});
